/* GIF Grid — Auto-advancing with IntersectionObserver */
(function() {
  'use strict';

  var container = document.querySelector('[data-gif-grid]');
  if (!container) return;

  var slides = container.querySelectorAll('[data-gif-index]');
  var dots = container.querySelectorAll('[data-gif-dot]');
  var total = slides.length;
  var current = 0;
  var timer;
  var isVisible = false;

  function show(index) {
    slides[current].classList.remove('is-active');
    dots[current].classList.remove('is-active');
    current = ((index % total) + total) % total;
    slides[current].classList.add('is-active');
    dots[current].classList.add('is-active');
  }

  function startTimer() {
    clearTimeout(timer);
    if (!isVisible) return;
    var duration = parseInt(slides[current].dataset.gifDuration) || 5000;
    timer = setTimeout(function() {
      show(current + 1);
      startTimer();
    }, duration);
  }

  /* Manual dot click */
  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      show(parseInt(dot.dataset.gifDot));
      startTimer();
    });
  });

  /* IntersectionObserver: only auto-advance when visible */
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      isVisible = entry.isIntersecting;
      if (isVisible) startTimer();
      else clearTimeout(timer);
    });
  }, { threshold: 0.3 });

  observer.observe(container);
})();
